import style from './StageStartModal.module.css';

import WorkRightAddMenuItem from 'components/WorkRight/WorkRightManualDir/WorkRightAddMenu/workRightAddMenuItem';
import { PUBLIC_ASSETS, address_server_short } from 'config';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { getDeviceModelById } from 'services/device.services';
import Icon from 'ui/Icon';

const Resource = ({ resource, index }) => {
  const { control, setValue } = useFormContext();
  const [deviceModel, setDeviceModel] = useState(null);

  useEffect(() => {
    const load = async () => {
      const { data } = await getDeviceModelById(resource.id);
      setDeviceModel(data);
    };
    load();
    setValue(`resources.[${index}].id`, resource.id);
    setValue(`resources.[${index}].type`, resource.type);
  }, []);

  return (
    <div className={style.resourceContainer}>
      <div className={style.resourceItemContainer}>
        <div>{resource.name}</div>
        <div className={style.resourceIconContainer}>
          <Icon
            width="100px"
            height="100px"
            src={address_server_short + PUBLIC_ASSETS + (resource?.image ?? '')}
          />
        </div>
      </div>
      <div className={style.resourceFieldsContainer}>
        {deviceModel?.user_fields?.map((item, i) => (
          <Controller
            key={item.id ?? i}
            name={`resources.[${index}].value.user_fields.[${i}]`}
            control={control}
            defaultValue={{ id: item.id, value: null }}
            render={({ field }) => (
              <WorkRightAddMenuItem
                item={{
                  type: item.type.type_name,
                  name: item.name,
                  setting: JSON.parse(item.setting),
                  id: item.id,
                }}
                selectItem={field?.value?.value}
                isUserFieldsOperation={true}
                setNewSelectItem={(value) => field.onChange({ id: item.id, value })}
              />
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default Resource;
